import { UPDATE_PAGINATION, RESET_PAGINATION } from "./actionTypes";

const paginationBase = {
    productsPag:{
        search:'',
        perPage: 20,
        page:1
    },
    salesPag:{
        search:'',
        perPage: 20,
        page:1
    }
}

const initialState = {
    pagination: { ...paginationBase },
};

const pagination = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_PAGINATION:
            // Actualizar el estado
            const newPagination = {...state.pagination,[action.payload.model]:action.payload.pagination}
            return {
                ...state,
                pagination: newPagination
            };
            return state
        case RESET_PAGINATION:
            return {
                ...state.pagination[action.payload.model],
                pagination: { ...paginationBase[action.payload.model] }
            };
        default:
            return state;
    }
};

export default pagination;
